import { CalendarGridColumnName } from '../../../grid/types/column.types';
import { dealDateValueGetter } from '../../../grid/utils/value-getters/deal-date';
import { DateFilterService } from '../../../services/date-filter.service';
import { FilterResultFacade } from '../filter-result-facade';
import {
  ConfigureOptionsParams,
  DateFilterModel,
  FilterOptions,
  FilterPassParams,
  IFilterComparator
} from '../filter-types';
import { FilterHandlerBase } from './base/filter-handler-base';
import { DefaultComparator } from './comparators/default-comparator';

export class DateFilterHandler extends FilterHandlerBase {
  private comparator: IFilterComparator<DateFilterModel>;

  get isInclusiveExclusive(): boolean {
    return false;
  }

  get name(): string {
    return CalendarGridColumnName.Date;
  }

  async configureFilterOptions(params: ConfigureOptionsParams): Promise<void> {
    // Set weekOf through setFilterService (the config service)
    // In ag-grid 31, this is how filters are configured
    params.setFilterService.weekOf = params.weekOf;
  }

  getFilterOptions(filterOptions: FilterOptions): any {
    return null;
  }

  hasValidDiff(
    options: FilterOptions,
    grid: Partial<DateFilterModel>,
    store: DateFilterModel
  ): boolean {
    return this.getValidDiffComparator(options).hasValidDiff(grid, store);
  }

  getValidDiffComparator(
    options: FilterOptions
  ): IFilterComparator<DateFilterModel> {
    if (!this.comparator) {
      this.comparator = new DefaultComparator();
    }
    this.comparator.applyFilterOptions(this.getFilterOptions(options));
    return this.comparator;
  }

  doFilterPass(params: FilterPassParams, result: FilterResultFacade) {
    let dealDateFilterPassed = true;
    const dealDate = params.filters[this.name];
    const data = params.deal;
    if (dealDate) {
      const dateFilterService = new DateFilterService();
      dealDateFilterPassed = dateFilterService.isInSelectedDateRange(
        dealDate.model.vm.weeks,
        dealDateValueGetter(data)
      );
    }
    result.applyDealFilerResult(data.id, this.name, dealDateFilterPassed);

    return dealDateFilterPassed;
  }
}
